module.exports = __webpack_public_path__ + "img/avatar-6.63383ad9.jpg";